import React from 'react';

import copy from 'copy-to-clipboard';
import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { notificationsActions, useStore } from '@modules';
import { NotificationTypesEnum } from '@modules/notifications/types';

import CopyIcon from './copy.svg';

import style from './CopyField.scss';

const cn = bemCssModules(style, 'CopyField');
const ti = getTestId('CopyField');

const { toast } = NotificationTypesEnum;

export type TCopyField = {
  value: string;
  caption: string;
  className?: string;
};

const CopyField: CustomFC<TCopyField> = ({ value, caption, className }) => {
  const { t } = useTranslation();
  const [, dispatch] = useStore();

  const handleCopy = () => {
    copy(value);
    dispatch(notificationsActions.add({ message: t('operations.copied'), type: toast }));
  };

  return (
    <div className={cn(null, [className])}>
      <p className={cn('caption')} data-testid={ti('caption')}>
        {caption}
      </p>
      <div className={cn('field')}>
        <button
          type="button"
          className={cn('button')}
          onClick={handleCopy}
          data-testid={ti('copy-button')}
        >
          <span className={cn('text')}>{value}</span>
          <CopyIcon />
        </button>
      </div>
    </div>
  );
};

export default CopyField;
